const ONES = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
  'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
const UNITS = [
  { value: 10000000, label: 'Crore' },
  { value: 100000, label: 'Lakh' },
  { value: 1000, label: 'Thousand' },
  { value: 100, label: 'Hundred' }
];

function inWords(n: number): string {
  if (n < 20) return ONES[n];
  if (n < 100) return TENS[Math.floor(n / 10)] + (n % 10 ? ' ' + ONES[n % 10] : '');

  const unit = UNITS.find(u => n >= u.value) as { value: number; label: string };
  const rest = n % unit.value;
  return inWords(Math.floor(n / unit.value)) + ' ' + unit.label + (rest ? ' ' + inWords(rest) : '');
}

/** Converts a number to Indian-system words (Crore / Lakh / Thousand / Hundred). */
export function numberToWords(num: number, zeroText = 'Zero'): string {
  if (num === 0) return zeroText;
  return inWords(num).trim();
}
